import React from "react";
import katex from "katex";
import "katex/dist/katex.min.css";

const renderInlineFormatting = (text: string, keyPrefix: string): React.ReactNode[] => {
  // Split by bold (**...**), italic (*...*), and newlines
  const tokens = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*|\n)/g);

  return tokens.map((token, i) => {
    if (token === "\n") {
      return <br key={`${keyPrefix}-${i}`} />;
    }
    if (token.startsWith("**") && token.endsWith("**")) {
      return <span key={`${keyPrefix}-${i}`} style={{ fontWeight: 900 }}>{token.slice(2, -2)}</span>;
    }
    if (token.startsWith("*") && token.endsWith("*")) {
      return <em key={`${keyPrefix}-${i}`}>{token.slice(1, -1)}</em>;
    }
    return <span key={`${keyPrefix}-${i}`}>{token}</span>;
  });
};

const MathText = ({ text }: { text: string }) => {
  // Split by display math ($$...$$) and inline math ($...$)
  const parts = text.split(/(\$\$[^$]+\$\$|\$[^$]+\$)/g);

  return (
    <span>
      {parts.map((part, i) => {
        if (part.startsWith("$$") && part.endsWith("$$")) {
          const math = part.slice(2, -2);
          const html = katex.renderToString(math, {
            throwOnError: false,
            displayMode: true,
          });
          return <span key={i} dangerouslySetInnerHTML={{ __html: html }} />;
        }
        if (part.startsWith("$") && part.endsWith("$")) {
          const math = part.slice(1, -1);
          const html = katex.renderToString(math, { throwOnError: false });
          return <span key={i} dangerouslySetInnerHTML={{ __html: html }} />;
        }
        return (
          <span key={i}>{renderInlineFormatting(part, String(i))}</span>
        );
      })}
    </span>
  );
};

export default MathText;
